import CategoryCard from '@/components/ui/display/category-card/CategoryCard.vue'

export default {
	name: "CategoryGrid",
	components: {
		CategoryCard,
	},
	props: {
		categories: {
			type: Array,
			required: true,
		},
		hide_label: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	methods: {
		onSectorSelected(sector) {
			this.$emit('categorySelected', sector);
		},
	},
};